module.exports = __webpack_public_path__ + "img/e_2_3_g.5df8349e.png";